import React from "react";
import QuadrantFlowImg from "../../../../Assets/Images/QuadrantFlowImg.png";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    padding: "16px 0px",
    boxSizing: "border-box",
    marginTop: "10px",
  },
  infoarea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  coverImage: {
    width: "100%",
    height: "300px",
    objectFit: "cover",
  },
  numberContainer: {
    marginTop: "80px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  numberCircle: {
    width: "56px",
    height: "56px",
    borderRadius: "100%",
    border: "4px solid #00577D ",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  numberText: {
    fontSize: "34px",
    fontWeight: "700",
    color: "#00577D",
    fontFamily: "Helvetica, sans-serif",
  },
  title: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#00577D",
    marginTop: "16px",
    fontFamily: "Helvetica, sans-serif",
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#C99212",
    fontFamily: "Helvetica, sans-serif",
  },
  footer: {
    width: "540px",
    borderTop: "1px solid #00577D",
    paddingTop: "5px",
    display: "flex",
    justifyContent: "space-between",
    position: "absolute",
    bottom: "20px",
    left: "20px",
    right: "20px",
  },
  footersection: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "400px",
  },
  footerTextheading: {
    fontSize: "10px",
    fontWeight: "700",
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
  },
  footerText: {
    fontSize: "8px",
    fontWeight: "400",
    color: "#76A3BE",
    fontFamily: "Helvetica, sans-serif",
  },
};

const HomeQuadrantFlow = ({ apiData, previewData, reportType, pageNumber }) => {
  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
        <div style={styles.page}>
          {/* Image and Heading Section */}
          <div style={styles.infoarea}>
            <img src={QuadrantFlowImg} alt="Quadrant Flow" style={styles.coverImage} />
            <div style={styles.numberContainer}>
              <div style={styles.numberCircle}>
                <span style={styles.numberText}>2</span>
              </div>
              <div style={styles.title}>FLOW</div>
              <div style={styles.subtitle}>HOW YOU MOVE</div>
            </div>
          </div>
        </div>
        <FooterPreview reportType={reportType} pageNumber={pageNumber} />
      </div>
    </div>

  );
};

export default HomeQuadrantFlow;
